import { getImageUrl } from '../hooks/use-image-voucher';

type CouponImageSource = {
    partner?: Array<{
        image?: string | null;
    } | null> | null;
    brand_image?: string | null;
    image?: string | null;
};

export const getCouponImageUri = (coupon: CouponImageSource): string => {
    const partnerImage = coupon.partner?.[0]?.image ?? '';
    const couponImage = coupon.image ?? '';
    const brandImg = coupon.brand_image ?? '';

    if (partnerImage) {
        return getImageUrl(partnerImage);
    }

    if (couponImage) {
        return getImageUrl(couponImage);
    }

    return brandImg;
};
